import {
  GET_GLOBAL_DATA,
  GET_GLOBAL_DATA_SUCCESS,
  GET_GLOBAL_DATA_LOAD_FAIL
} from './action';

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  data: [],
  extraData: {},
};


export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_GLOBAL_DATA:
      return {
        ...state,
        loading: true,
      };
    case GET_GLOBAL_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: {
          topRightLinks: { links: action?.result?.header[0]["top_navigation_bar"] || [] },
          userDataDropdownLogged: { links: action?.result?.header[0]["content_logged_in"]["account_menu"] || [] },
          userDataDropdownGuest: { links: action?.result?.header[0]["content_logged_out"]["account_menu"] || [] },
          loggedUserDataDropdown:  { links: action?.result?.header[0]["content_logged_in"]["side_menu"] || [] },
          guestUserDataDropdown: { links: action?.result?.header[0]["content_logged_out"]["side_menu"] || [] },
          footerContent: action?.result?.footer[0] || [],
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    case GET_GLOBAL_DATA_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
}

function buildNestedLinks(linksList) {
  const topNavbarLinks = []
  linksList.map((l1Link) => {
    const l1LinkObj = createLinkObject(l1Link)
    l1Link && l1Link.items && l1Link.items.map((l2Link) => {
      const l2LinkObj = createLinkObject(l2Link)
      l2Link && l2Link.items && l2Link.items.map((l3Link) => {
        const l3LinkObj = createLinkObject(l3Link)
        l2LinkObj.links.push(l3LinkObj)
      })
      l1LinkObj.links.push(l2LinkObj)
    })
    topNavbarLinks.push(l1LinkObj)
  });
  return { "links": topNavbarLinks };
}

function getLoggedInObjectDetails(contentLoggedIn) {
  return contentLoggedIn.map(loggedContent => {
    return {
      "name": loggedContent.label || "",
      "url": loggedContent.url || ""
    }
  })
}

function createLinkObject(linkObject) {
  let obj = {}
  obj['name'] = linkObject.title || ""
  obj["text"] = linkObject.label || ""
  obj["url"] = linkObject.url || ""
  obj["imageUrl"] = ""
  obj["index"] = ""
  obj["links"] = []
  return obj;
}